import React, { FC } from 'react'
import {  useReactiveVar } from '@apollo/client'
import { Collapse } from 'components/Collapse'

import { feedFiltersVar, labelCodeIdVar, feedTotalVar, showMyFilterForZoneVar, spaceIdVar } from 'modulesCommon/store'
import { FILTER_FIELDS, FOLLOWED_FILTER_OPTIONS } from 'shared/consts/filter'
import { useZonesList } from 'modulesCommon/serviceHooks'
import { useTags } from 'modulesCommon/Tags/useTags'
import { FilterContainer, FilterList } from 'components'
import { useSpaceZone } from 'modulesCommon/Filters/serviceHooks/useSpaceZone'
import { filterFollowOptions } from 'modulesCommon/Filters/utils'
import { FilterTags } from 'components/Filter'
import { FilterButtonGroup } from 'components/Filter/FilterButtonGroup/FilterButtonGroup'
import { useFeedFilter } from '../serviceHooks/useFeedFilter'
import { formatToOptionsById } from 'shared/utils/labels'
import { RANGE_FILTER_OPTIONS } from  'modules/Feed/constants'

export const FeedFilters: FC = () => {
  const currentLabel = useReactiveVar(labelCodeIdVar)
  const spaceId = useReactiveVar(spaceIdVar)
  const feedTotal = useReactiveVar(feedTotalVar)
  const filters = useReactiveVar(feedFiltersVar)
  const isShownMyFilter = useReactiveVar(showMyFilterForZoneVar)
  const { getUnitsByZoneId } = useZonesList()
  const { spaceZoneOptions } = useSpaceZone()
  const { tags } = useTags({ labelId: currentLabel, spaceId })

  const unitOptions = getUnitsByZoneId(currentLabel).map(formatToOptionsById)

  const {
    onToggleFollowed,
    isResetDisabled,
    onReset,
    selectedFilters
  } = useFeedFilter(filters, feedFiltersVar, unitOptions, spaceZoneOptions)

  return (
    <FilterContainer
      onClear={onReset}
      isClearDisabled={isResetDisabled}
      selected={selectedFilters}
      totalTitle={`${feedTotal} stories.`}
    >
      <FilterButtonGroup
        currentValue={filters.followed}
        onToggle={onToggleFollowed('followed')}
        optionList={filterFollowOptions(FOLLOWED_FILTER_OPTIONS, isShownMyFilter)}
      />
      <Collapse list={[
        ...spaceZoneOptions.length ? [{
          title: 'Select Zone',
          id: '1',
          content: (
            <FilterList
              value={filters.label_id}
              onSelect={onToggleFollowed(FILTER_FIELDS.LABELS)}
              options={[
                {
                  label: 'All Zones',
                  value: ''
                },
                ...spaceZoneOptions
              ]}
            />
          ),
          expand: false
        }] : [],
        ...!spaceId ? [{
          title: 'Select Unit',
          id: '1',
          content: (
            <FilterList
              value={filters.unit_id}
              onSelect={onToggleFollowed(FILTER_FIELDS.UNITS)}
              options={[
                {
                  label: 'All units',
                  value: ''
                },
                ...unitOptions
              ]}
            />
          ),
          expand: false
        }] : [],
        {
          title: 'Select Time Frame',
          id: '2',
          content: (
            <FilterList
              value={filters.range}
              onSelect={onToggleFollowed(FILTER_FIELDS.RANGE)}
              options={RANGE_FILTER_OPTIONS}
              customOption={[{
                label: 'Custom range',
                type: 'range'
              }]}
            />
          ),
          expand: false
        }
      ]}>
      </Collapse>
      <h3 className="filter-wrapper__title subtitle">Filter by Tags</h3>
      <FilterTags
        values={[...filters.tags]}
        onSelect={onToggleFollowed(FILTER_FIELDS.TAGS)}
        tagsList={tags}
      />
    </FilterContainer>
  )
}
